import React from "react";
import { useShowFundByIsin } from "@bn/api/apiv1";
import { RanksAndRisksContainer } from "./RanksAndRisksContainer";

export interface Props {
  isin: string;
}

export const RanksAndRisks = ({ isin }: Props) => {
  const { data, isFetching, isPending } = useShowFundByIsin(
    { isin, includeFundamentals: true },
    {
      enabled: !!isin,
      // A fund we hold no master data for is an empty state, not a failure —
      // the ratings block simply renders blank, so don't spend retries on it.
      retry: (failureCount, error) =>
        (error as AxiosApiError)?.response?.status !== 404 && failureCount < 3,
    }
  );

  return (
    <RanksAndRisksContainer
      isFetching={isFetching || isPending}
      fwwFundStars={data?.ratingFwwFundstars}
      srri={data?.riskLevelSrri}
    />
  );
};
